export const AuthenticationButton = ({ label,type='button' }) => {
  return (
    <button type={type} className="mt-[50px] w-full h-[50px] rounded-[8px] bg-primary font-glacial text-[20px] font-bold leading-[20px] text-clientWhite hover:bg-opacity-80">
      {label}
    </button>
  );
};
